import { render, staticRenderFns } from "./CallError.vue?vue&type=template&id=6cfb73e5&scoped=true&"
import script from "./CallError.vue?vue&type=script&lang=js&"
export * from "./CallError.vue?vue&type=script&lang=js&"
import style0 from "./CallError.vue?vue&type=style&index=0&id=6cfb73e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfb73e5",
  null
  
)

export default component.exports